import { gql } from 'graphql-request'

export const REMOVE_BOOK = gql`
  mutation RemoveBook($removeBookId: Int!) {
    removeBook(id: $removeBookId) {
      message
    }
  }
`

export const REMOVE_BOOKS = gql`
  mutation RemoveBooks($ids: [Int!]!) {
    removeBooks(ids: $ids) {
      message
    }
  }
`
